<div class="dashboard-home">
    <div class="img-box">
        <img src="../../assets/images/custom/company-logo/bpims-logo2.png" alt="bpims-logo">
    </div>
</div>